"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserPhoto = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var userInfo_1 = require("../../model/userInfo");
var service_1 = require("../../../library/base/service");
var GetUserPhoto = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetUserPhoto, _super);
    function GetUserPhoto() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '头像获取';
        _this.code = '101058';
        _this.desc = '头像获取';
        _this.requestParams = new userInfo_1.GetUserPhotoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetUserPhoto;
}(service_1.BaseService));
exports.GetUserPhoto = GetUserPhoto;
//# sourceMappingURL=getUserPhoto.js.map